import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @atlaskit
import FieldText from '@atlaskit/field-text';
import Form, { Field } from '@atlaskit/form';
import Modal from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';

// @source
import { crypto } from '../../../../utils';
import { fields } from '../../../../constants';
import { Messages } from '../../../components';
import { User } from '../../../../tools';
import { User as API } from '../../../../server';
import ErrorModal from './ErrorModal';
import Styled from '../styled';

const initialState = {
  isLoading: false,
  message: false,
};

const initialStatic = {
  name: '',
  password: '',
  surname: '',
  username: '',
};

const getUsernameEmail = email => email.split('@')[0];

const getCompanyEmail = () => {
  const { Email } = User.getUserInfo();
  return Email.split('@')[1];
};

class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.static = initialStatic;
    this.sync = false;
    this.unmount = false;
    this.uuid = crypto.decode(this.props.uuid);
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
    this.registerField = this.registerField.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onSubmitHandle(event) {
    event.preventDefault();
    const validate = this.form.validate();

    if (!validate.isInvalid) {
      this.setState({
        isLoading: true,
        message: false,
      });

      API.update({
        data: [{
          username: this.user.Username,
          state: {
            ...this.static,
            username: `${this.static.username}@${getCompanyEmail()}`,
          },
        }],
        dispatch: this.props.dispatch,
        success: () => {
          this.props.onClose();
        },
        error: (messages) => {
          this.setStateUnmount({
            isLoading: false,
            message: (
              <Messages
                component="Modal"
                items={messages}
                onClose={() => this.setState({ message: false })}
              />
            ),
          });
        },
      });
    }
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  setStatic(state) {
    this.static = { ...this.static, ...state };
  }

  registerField(node) {
    if (this.form && node) {
      this.form.registerField(node.state.fieldState);
    }
  }

  renderFormBody() {
    if (!this.sync) {
      this.sync = true;
      this.setStatic({
        name: this.user.Name,
        password: this.user.Password,
        surname: this.user.Surname,
        username: getUsernameEmail(this.user.Username),
      });
    }

    return (
      <div>
        <p>You can change the following user information.</p>
        <Styled.FieldGroup>
          <Field
            {...fields.name.field}
            ref={this.registerField}
          >
            <FieldText
              {...fields.name.fieldText}
              onChange={event => this.setStatic({ name: event.target.value })}
              value={this.static.name}
            />
          </Field>
          <Field
            {...fields.surname.field}
            ref={this.registerField}
          >
            <FieldText
              {...fields.surname.fieldText}
              onChange={event => this.setStatic({ surname: event.target.value })}
              value={this.static.surname}
            />
          </Field>
        </Styled.FieldGroup>
        <Styled.FieldGroup>
          <Field
            {...fields.username.field}
            ref={this.registerField}
          >
            <FieldText
              {...fields.username.fieldText}
              onChange={event => this.setStatic({ username: event.target.value })}
              value={this.static.username}
            />
          </Field>
          <Field label="Company Email">
            <FieldText
              disabled
              shouldFitContainer
              value={`@${getCompanyEmail()}`}
            />
          </Field>
        </Styled.FieldGroup>
        <Field
          {...fields.password.field}
          ref={this.registerField}
        >
          <FieldText
            {...fields.password.fieldText}
            onChange={event => this.setStatic({ password: event.target.value })}
            value={this.static.password}
          />
        </Field>
      </div>
    );
  }

  render() {
    this.user = this.props.users.data.find(item => item.Username === this.uuid);

    if (this.props.users.override && !this.user) {
      return <ErrorModal onClose={this.props.onClose} />;
    }

    return (
      <Form
        name="edit-user"
        onSubmit={this.onSubmitHandle}
        ref={(node) => { this.form = node; }}
      >
        <Modal
          heading="Edit user"
          width="medium"
          onClose={this.props.onClose}
          actions={[{
            appearance: 'primary',
            isDisabled: !this.user,
            isLoading: this.state.isLoading,
            onClick: this.onSubmitHandle,
            text: 'Save user',
            type: 'submit',
          }, {
            appearance: 'subtle',
            onClick: this.props.onClose,
            text: 'Cancel',
          }]}
        >
          {this.props.users.override ? this.renderFormBody() : (
            <Styled.SpinnerScope>
              <Spinner size="medium" />
            </Styled.SpinnerScope>
          )}
          {this.state.message}
        </Modal>
      </Form>
    );
  }
}

EditUser.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  users: PropTypes.shape().isRequired,
  uuid: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  users: state.User,
});

export default connect(mapStateToProps)(EditUser);
